// Search button actions
var searchButton = document.querySelector('.search-button')

var productSearch = document.querySelector('.woocommerce-product-search')
searchButton.addEventListener('click', function() {
  productSearch.classList.toggle('open')
});

var searchButton = document.querySelector('.search-button')

var siteHeader = document.querySelector('.site-header')
searchButton.addEventListener('click', function() {
  siteHeader.classList.toggle('search-active')
});

// Filter on/off
var filterButton = document.querySelector('.filter-box .activate-filter')
var filterContent = document.querySelector('.filter-box .filter-content')

if (filterButton){
  filterButton.addEventListener('click', function() {
    filterContent.classList.toggle('open')
    filterButton.classList.toggle('active')
  });
}

